const state = {
  viewerId: null,
  viewerName: null,
  organisationId: null,
  hasLogin: null,
  organisationPortalUrl: null,
  loginMethods: [],
  loginPermission: null,
  portalAppId: null,
  license: null,
}

const getters = {
  getViewerId: state => state.viewerId,
  getViewerName: state => state.viewerName,
  getOrganisationId: state => state.organisationId,
  getHasLogin: state => state.hasLogin,
  getOrganisationPortalUrl: state => state.organisationPortalUrl,
  getLoginMethods: state => state.loginMethods,
  getLoginPermission: state => state.loginPermission,
  getPortalAppId: state => state.portalAppId,
  getLicense: state => state.license,
}

const mutations = {
  setGeneralInfo (state, generalInfo) {
    state.viewerId = generalInfo.viewerId
    state.viewerName = generalInfo.viewerName
    state.organisationId = generalInfo.organisationId
    state.hasLogin = generalInfo.hasLogin
    state.loginMethods = generalInfo.loginMethods
    state.loginPermission = generalInfo.loginPermission
    state.license = generalInfo.license
    if (generalInfo.organisationPortalUrl) {
      if (generalInfo.organisationPortalUrl.endsWith('/')) {
        state.organisationPortalUrl = generalInfo.organisationPortalUrl.substring(0, generalInfo.organisationPortalUrl.length - 1)
      } else {
        state.organisationPortalUrl = generalInfo.organisationPortalUrl
      }
    } else {
      state.organisationPortalUrl = null
    }
  },
  setPortalAppId (state, appid) {
    state.portalAppId = appid
  },
}

const actions = {
  setGeneralInfo ({ commit }, generalInfo) {
    commit('setGeneralInfo', generalInfo)
  },
  setPortalAppId ({ commit }, appId) {
    commit('setPortalAppId', appId)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
